

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://460ff4620fa44cba8df530afde949785@sentry.wixpress.com/5803", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/e46fc5f0e91b8aa0/packages/members-area-notifications/src/components/OoiNotifications/Widget/index.tsx';
    import createController from '/home/builduser/work/e46fc5f0e91b8aa0/packages/members-area-notifications/src/components/OoiNotifications/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'OoiNotifications';
    var projectName = 'members-area-notifications';
    var sentryConfig = {
      DSN: 'https://460ff4620fa44cba8df530afde949785@sentry.wixpress.com/5803',
      id: 'undefined',
      projectName: 'members-area-notifications',
      teamName: 'ping',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/e46fc5f0e91b8aa0/packages/members-area-notifications/src/components/OoiNotifications/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["viewer-apps-14f25924-5664-31b2-9568-f9c5ed98c9b1"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/e46fc5f0e91b8aa0/packages/members-area-notifications/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"app.settings.tabs.design.title-font.title":"Title text","app.widget.dummy-data.message.1":"John Smith likes your post \"some post\".","app.settings.tabs.design.indicator-color.title":"Notification circle color and opacity","app.settings.tabs.design.background-section.title":"Backgrounds and borders","app.settings.tabs.design.border-color.title":"Border opacity and color","app.widget.dummy-data.message.3":"Brad Pitt likes your post \"some post\".","app.settings.tabs.design":"Design","app.widget.notification-item.time-ago":"{time, date}","app.widget.empty-state.title":"No Notifications Yet","app.settings.tabs.design.border-width.title":"Border width (px)","app.widget.dummy-data.message.2":"Chew Chang likes your post \"some post\".","app.settings.tabs.design.background-color.title":"Background opacity and color","app.settings.tabs.design.primary-font.title":"Notification description text","app.settings.tabs.design.text-color.title":"Text color","app.widget.notification-item.time-ago.relative":"{time, timeRelative}","app.widget.mark-all-as-read":"Mark all as read ({unseenCount})","app.widget.title":"Notifications","app.widget.empty-state.subtitle":"Make comments, like posts or follow members to get things going."};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14f25924-5664-31b2-9568-f9c5ed98c9b1";
    var componentId = "14f2595a-a352-3ff1-9b3c-4d21861fe58f";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/e46fc5f0e91b8aa0/packages/members-area-notifications/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
